import React, { useState, useEffect } from "react";
import { supabase } from "../utils/supabaseClient";
import { CalendarClock, MonitorPlay, Users } from "lucide-react";
import LoadingSpinner from "./LoadingSpinner";
import WebinarCarousel from "./WebinarCarousel";
import "../styles/WebinarDisplay.css";

const WebinarDisplay = () => {
  const [webinars, setWebinars] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchWebinars();
  }, []);

  const fetchWebinars = async () => {
    try {
      const { data, error } = await supabase
        .from("webinars")
        .select("*")
        .order("date", { ascending: true });

      if (error) throw error;
      setWebinars(data);
    } catch (err) {
      console.error("Error fetching webinars:", err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  const formatTime = (timeString) => {
    try {
      const [hours, minutes] = timeString.split(":");
      const hour = parseInt(hours);
      const ampm = hour >= 12 ? "PM" : "AM";
      const formattedHour = hour % 12 || 12;
      return `${formattedHour}:${minutes} ${ampm}`;
    } catch (error) {
      return timeString;
    }
  };

  if (loading) return <LoadingSpinner />;
  if (error)
    return (
      <div className="error-message">
        Error loading webinars: {error.message}
      </div>
    );
  if (!webinars || webinars.length === 0) {
    return (
      <div className="webinar-empty-state">
        <div className="empty-state-content">
          <div className="empty-state-illustrations">
            <div className="illustration-group main">
              <CalendarClock size={64} className="icon main-icon" />
            </div>
            <div className="illustration-group secondary">
              <MonitorPlay size={40} className="icon secondary-icon-1" />
              <Users size={40} className="icon secondary-icon-2" />
            </div>
          </div>
          <h2>No Upcoming Webinars</h2>
          <p>We're preparing some exciting webinars for you.</p>
          <p className="subtitle">
            Stay tuned for upcoming events and announcements!
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="webinar-section">
      <WebinarCarousel
        webinars={webinars}
        formatDate={formatDate}
        formatTime={formatTime}
      />
    </div>
  );
};

export default WebinarDisplay;
